import { useState } from "react";

interface IYesNo {
  condition: string;
  onChange: (value: boolean) => void;
  tip?: string;
}

const YesNo: React.FC<IYesNo> = (data) => {
  const [active, setActive] = useState<number>(0);
  const [showPopup, setShowPopup] = useState<boolean>(false);

  const togglePopup = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowPopup(!showPopup);
  };

  const handleYesClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setActive(1);
    data.onChange(true);
  };

  const handleNoClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setActive(2);
    data.onChange(false);
  };

  return (
    <>
      <div className="grid-x hide-for-small-only" style={{ paddingBottom: 32 }}>
        <div
          className="cell small-12 medium-8"
          style={{
            paddingRight: 10,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              color: "#212126",
              fontSize: 25,
              fontWeight: 500,
              lineHeight: "27px",
            }}
          >
            {data.condition}
            {data.tip && (
              <div>
                <button
                  type="button"
                  style={{
                    color: "#1B54C2",
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: 18,
                  }}
                  onClick={togglePopup}
                >
                  What is Medicaid?
                </button>
              </div>
            )}
            {showPopup && (
              <div
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  lineHeight: "42px",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "#F5F9FD",
                  border: "1px solid #ccc",
                  padding: "80px 56px",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
                  zIndex: 9999,
                  fontSize: 25,
                  color: "#212126",
                  width: "80%",
                  maxWidth: "820px",
                  minHeight: "335px",
                  fontWeight: "normal",
                }}
              >
                <button
                  type="button"
                  onClick={togglePopup}
                  style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    backgroundColor: "#DAE9FF",
                    border: "none",
                    borderRadius: 0,
                    fontSize: 30,
                    cursor: "pointer",
                    color: "#0065F2",
                    width: 58,
                    height: 58,
                  }}
                  dangerouslySetInnerHTML={{
                    __html:
                      '&times; <span class="screen-reader-text">Close</span>',
                  }}
                ></button>
                {data.tip}
              </div>
            )}
          </div>
        </div>
        <div className="cell small-12 medium-4" style={{ display: "flex" }}>
          <button
            type="button"
            onClick={handleYesClick}
            style={{
              flex: 1,
              marginRight: 24,
              boxShadow:
                "0px 4px 4px 0px rgba(0, 0, 0, 0.05), 0px 10px 10px 0px rgba(0, 0, 0, 0.10)",
              borderColor: active === 1 ? "#1B54C2" : "#D3E1F0",
              borderWidth: 2,
              marginBottom: 0,
            }}
            className="button hollow"
          >
            Yes
          </button>
          <button
            type="button"
            onClick={handleNoClick}
            style={{
              flex: 1,
              boxShadow:
                "0px 4px 4px 0px rgba(0, 0, 0, 0.05), 0px 10px 10px 0px rgba(0, 0, 0, 0.10)",
              borderColor: active === 2 ? "#1B54C2" : "#D3E1F0",
              borderWidth: 2,
              marginBottom: 0,
            }}
            className="button hollow"
          >
            No
          </button>
        </div>
      </div>
      <div className="grid-x show-for-small-only">
        <div
          className="cell small-12 medium-8"
          style={{ paddingRight: 10, display: "flex", alignItems: "center" }}
        >
          <div
            style={{
              color: "#212126",
              fontSize: 25,
              fontWeight: 500,
              lineHeight: "27px",
            }}
          >
            {data.condition}
            {data.tip && (
              <div>
                <button
                  type="button"
                  style={{
                    color: "#1B54C2",
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: 18,
                  }}
                  onClick={togglePopup}
                >
                  What is Medicaid?
                </button>
              </div>
            )}
            {showPopup && (
              <div
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "white",
                  border: "1px solid #ccc",
                  padding: "80px 56px",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
                  zIndex: 9999,
                  fontSize: 25,
                  color: "#212126",
                  width: "80%",
                  maxWidth: "820px",
                  minHeight: "335px",
                  fontWeight: "normal",
                }}
              >
                <button
                  type="button"
                  onClick={togglePopup}
                  style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    backgroundColor: "#DAE9FF",
                    border: "none",
                    borderRadius: 0,
                    fontSize: 30,
                    cursor: "pointer",
                    color: "#0065F2",
                    width: 58,
                    height: 58,
                  }}
                  dangerouslySetInnerHTML={{
                    __html:
                      '&times; <span class="screen-reader-text">Close</span>',
                  }}
                ></button>
                {data.tip}
              </div>
            )}
          </div>
        </div>
        <div
          className="cell small-12 medium-4"
          style={{ display: "flex", paddingTop: 24, paddingBottom: 48 }}
        >
          <button
            type="button"
            onClick={handleYesClick}
            style={{
              flex: 1,
              marginRight: 24,
              boxShadow:
                "0px 4px 4px 0px rgba(0, 0, 0, 0.05), 0px 10px 10px 0px rgba(0, 0, 0, 0.10)",
              borderColor: active === 1 ? "#1B54C2" : "#D3E1F0",
              borderWidth: 2,
            }}
            className="button hollow"
          >
            Yes
          </button>
          <button
            type="button"
            onClick={handleNoClick}
            style={{
              flex: 1,
              boxShadow:
                "0px 4px 4px 0px rgba(0, 0, 0, 0.05), 0px 10px 10px 0px rgba(0, 0, 0, 0.10)",
              borderColor: active === 2 ? "#1B54C2" : "#D3E1F0",
              borderWidth: 2,
            }}
            className="button hollow"
          >
            No
          </button>
        </div>
      </div>
    </>
  );
};

export default YesNo;
